import React, { useEffect, useState } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";
import { api, errMsg } from "../lib/api";
import { Card } from "../components/ui/card";
import { Button } from "../components/ui/button";
import { toast } from "sonner";
import { isoToDisplayDateTime } from "../components/DateInput";

export default function AuditLogPage() {
  const [data, setData] = useState({ items: [], total: 0, page: 1, total_pages: 1 });
  const [page, setPage] = useState(1);

  useEffect(() => {
    api.get("/audit-log", { params: { page, page_size: 25 } }).then((r) => setData(r.data)).catch((e) => toast.error(errMsg(e)));
  }, [page]);

  return (
    <div className="space-y-6" data-testid="audit-page">
      <div>
        <h1 className="text-2xl sm:text-3xl font-bold tracking-tight text-slate-900">Audit Log</h1>
        <p className="text-sm text-slate-500 mt-1">Total <span className="font-semibold" data-testid="audit-total">{data.total}</span> aktivitas tercatat</p>
      </div>
      <Card className="rounded-2xl overflow-hidden border-slate-200/80">
        <div className="divide-y divide-slate-100" data-testid="audit-list">
          {data.items.map((a) => (
            <div key={a.id} className="p-4 flex flex-col sm:flex-row sm:items-center gap-2 sm:gap-4 text-sm">
              <span className="font-mono text-xs text-slate-400 shrink-0 w-40">{isoToDisplayDateTime(a.timestamp)}</span>
              <span className="font-semibold text-slate-800 shrink-0">{a.username || "—"}<span className="text-slate-400 font-normal"> ({a.role || "anon"})</span></span>
              <span className="px-2 py-0.5 rounded-md bg-slate-100 text-slate-700 text-xs font-mono shrink-0">{a.action}</span>
              <span className="text-slate-500 truncate">{a.resource}{a.resource_id ? ` · ${a.resource_id.slice(0, 8)}` : ""}{a.detail ? ` · ${JSON.stringify(a.detail)}` : ""}</span>
            </div>
          ))}
          {data.items.length === 0 && <p className="p-8 text-center text-slate-400">Belum ada aktivitas.</p>}
        </div>
      </Card>
      <div className="flex items-center justify-between">
        <Button variant="outline" className="rounded-xl" disabled={page <= 1} onClick={() => setPage((p) => p - 1)} data-testid="audit-prev"><ChevronLeft className="h-4 w-4" /></Button>
        <span className="text-sm text-slate-500">Hal. {data.page} / {data.total_pages || 1}</span>
        <Button variant="outline" className="rounded-xl" disabled={page >= data.total_pages} onClick={() => setPage((p) => p + 1)} data-testid="audit-next"><ChevronRight className="h-4 w-4" /></Button>
      </div>
    </div>
  );
}
